import { useEffect, useState } from 'react';
import './../styles/cart.css';
import { HashLoader } from 'react-spinners';
import ToastNotification, { showToast } from '../components/toasts/ToastNotification';
import { deleteFromCart, getCart } from '../api/cart.api';
import { MdDelete } from "react-icons/md";
import EMPTY_CART from './../assets/images/empty_cart.png';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';

export const Cart = () => {
    const [loading, setLoading] = useState(false);
    const [cart, setUserCart] = useState(null);
    const { setCart } = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Giỏ hàng của bạn';
        fetchCart();
    }, []);

    const fetchCart = async () => {
        try {
            setLoading(true);

            const res = await getCart();

            if (res.success) {
                setUserCart(res.data.cart);
            }
        } catch (error) {
            showToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    const handleDeleteCart = async () => {
        try {
            setLoading(true);

            const res = await deleteFromCart();

            if (res.success) {
                setUserCart(null);
                setCart(0);
            }
        } catch (error) {
            showToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <div style={{ height: "100vh" }} className="loader-container">
                <HashLoader color="#fff" />
            </div>
        );
    }

    return (
        <div className='user-cart-container'>
            <ToastNotification />
            <div className='user-cart-wrapper'>
                <div className='cart-header-container'>
                    <h3>Giỏ hàng của bạn</h3>
                    {cart?.product && <button onClick={handleDeleteCart} className='remove-product-button'><MdDelete /></button>}
                </div>
                {cart?.product ?
                    <div className='cart-product-container'>
                        <img className='cart-product-img' src={cart?.product?.product_imgs[0]} alt='Product'></img>
                        <div className='cart-product-name-quantity'>
                            <p>{cart?.product?.product_name}</p>
                            <p>x1</p>
                        </div>
                        <button onClick={() => navigate(`/product/${cart?.product?.product_slug}`)} className='cart-checkout-button'>Đi tới thanh toán</button>
                    </div>
                    :
                    <div className='empty-cart-container'>
                        <img className='empty-cart-img' src={EMPTY_CART} alt='Empty Cart'></img>
                        <p>Ôi không! Giỏ hàng trống trơn rồi, đi shopping thôi nào!</p>
                    </div>
                }
            </div>
        </div>
    )
}